import FormHelper from "@/module/FormHelper";
import ExchangeRateProvider from "@/module/ExchangeRate/ExchangeRateProvider";

export default class SimplifiedInvoiceChecker {
  private countryCurrencies: { [key: string]: string } = {
    CZ: "CZK",
    "*": "EUR",
  };

  private countryLimits: { [key: string]: number } = {
    CZ: 10000,
    "*": 100,
  };

  constructor() {}

  async isAllowed(
    totalPriceIncludingVat: number,
    currency: string,
    domesticCountry: string,
    exchangeRateProvider: ExchangeRateProvider,
  ): Promise<boolean> {
    const domesticCurrency = this.getDomesticCurrency(domesticCountry);
    let price: number | undefined = totalPriceIncludingVat;

    if (currency !== domesticCurrency) {
      price = await FormHelper.toDomesticCurrency(
        totalPriceIncludingVat,
        currency,
        exchangeRateProvider,
      );
    }

    if (price === undefined) {
      return false;
    }

    return price <= this.getCountryLimit(domesticCountry);
  }

  private getDomesticCurrency(country: string): string {
    if (this.countryCurrencies.hasOwnProperty(country)) {
      return this.countryCurrencies[country];
    }

    return this.countryCurrencies["*"];
  }

  private getCountryLimit(country: string): number {
    if (this.countryLimits.hasOwnProperty(country)) {
      return this.countryLimits[country];
    }

    return this.countryLimits["*"];
  }
}
